export const geoPolData = {
  APAC: {
    label: "Asia Pacific",
    value: "APAC",
    countries: {
      AU: {
        label: "AUSTRALIA",
        value: "AU",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      BD: {
        label: "BANGLADESH",
        value: "BD",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      BN: {
        label: "BRUNEI DARUSSALAM",
        value: "BN",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      KH: {
        label: "CAMBODIA",
        value: "KH",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      CN: {
        label: "CHINA",
        value: "CN",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      CK: {
        label: "COOK ISLANDS",
        value: "CK",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      FJ: {
        label: "FIJI",
        value: "FJ",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      HK: {
        label: "HONG KONG",
        value: "HK",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      IN: {
        label: "INDIA",
        value: "IN",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      ID: {
        label: "INDONESIA",
        value: "ID",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      KR: {
        label: "KOREA, REPUBLIC OF",
        value: "KR",
        states: [],
        languages: [
          {
            label: "Korean",
            value: "Korean",
          },
        ],
      },
      LA: {
        label: "LAOS",
        value: "LA",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      MO: {
        label: "MACAO",
        value: "MO",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      MY: {
        label: "MALAYSIA",
        value: "MY",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      MV: {
        label: "MALDIVES",
        value: "MV",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      MH: {
        label: "MARSHALL ISLANDS",
        value: "MH",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      MN: {
        label: "MONGOLIA",
        value: "MN",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      MM: {
        label: "MYANMAR",
        value: "MM",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      NP: {
        label: "NEPAL",
        value: "NP",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      NZ: {
        label: "NEW ZEALAND",
        value: "NZ",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      PK: {
        label: "PAKISTAN",
        value: "PK",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      PG: {
        label: "PAPUA NEW GUINEA",
        value: "PG",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      PH: {
        label: "PHILIPPINES",
        value: "PH",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      WS: {
        label: "SAMOA",
        value: "WS",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      SG: {
        label: "SINGAPORE",
        value: "SG",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      SB: {
        label: "SOLOMON ISLANDS",
        value: "SB",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      LK: {
        label: "SRI LANKA",
        value: "LK",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      TW: {
        label: "TAIWAN",
        value: "TW",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      TH: {
        label: "THAILAND",
        value: "TH",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
      VN: {
        label: "VIETNAM",
        value: "VN",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "Chinese",
            value: "Chinese",
          },
        ],
      },
    },
  },
  EMEA: {
    label: "Europe, Middle East, and Africa",
    value: "EMEA",
    countries: {
      AF: {
        label: "AFGHANISTAN",
        value: "AF",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      AL: {
        label: "ALBANIA",
        value: "AL",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      DZ: {
        label: "ALGERIA",
        value: "DZ",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      AD: {
        label: "ANDORRA",
        value: "AD",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      AO: {
        label: "ANGOLA",
        value: "AO",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      AM: {
        label: "ARMENIA",
        value: "AM",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      AT: {
        label: "AUSTRIA",
        value: "AT",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      AZ: {
        label: "AZERBAIJAN",
        value: "AZ",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      BH: {
        label: "BAHRAIN",
        value: "BH",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      BY: {
        label: "BELARUS",
        value: "BY",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      BE: {
        label: "BELGIUM",
        value: "BE",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      BJ: {
        label: "BENIN",
        value: "BJ",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      BA: {
        label: "BOSNIA AND HERZEGOVINA",
        value: "BA",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      BW: {
        label: "BOTSWANA",
        value: "BW",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      BG: {
        label: "BULGARIA",
        value: "BG",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      BF: {
        label: "BURKINA FASO",
        value: "BF",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      BI: {
        label: "BURUNDI",
        value: "BI",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      CM: {
        label: "CAMEROON",
        value: "CM",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      CV: {
        label: "CAPE VERDE ISLAND",
        value: "CV",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      CF: {
        label: "CENTRAL AFRICAN REPUBLIC",
        value: "CF",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      TD: {
        label: "CHAD",
        value: "TD",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      KM: {
        label: "COMOROS",
        value: "KM",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      CG: {
        label: "CONGO",
        value: "CG",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      CI: {
        label: "COTE DIVOIRE",
        value: "CI",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      HR: {
        label: "CROATIA",
        value: "HR",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      CY: {
        label: "CYPRUS",
        value: "CY",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      CZ: {
        label: "CZECH REPUBLIC",
        value: "CZ",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      DK: {
        label: "DENMARK",
        value: "DK",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      DJ: {
        label: "DJIBOUTI",
        value: "DJ",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      EG: {
        label: "EGYPT",
        value: "EG",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      GQ: {
        label: "EQUATORIAL GUINEA",
        value: "GQ",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      ER: {
        label: "ERITREA",
        value: "ER",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      EE: {
        label: "ESTONIA",
        value: "EE",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      ET: {
        label: "ETHIOPIA",
        value: "ET",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      FO: {
        label: "FAROE ISLANDS",
        value: "FO",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      FI: {
        label: "FINLAND",
        value: "FI",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      FR: {
        label: "FRANCE",
        value: "FR",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      GA: {
        label: "GABON",
        value: "GA",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      GM: {
        label: "GAMBIA",
        value: "GM",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      GE: {
        label: "GEORGIA",
        value: "GE",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      DE: {
        label: "GERMANY",
        value: "DE",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      GH: {
        label: "GHANA",
        value: "GH",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      GI: {
        label: "GIBRALTAR",
        value: "GI",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      GR: {
        label: "GREECE",
        value: "GR",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      GN: {
        label: "GUINEA",
        value: "GN",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      GW: {
        label: "GUINEA-BISSAU",
        value: "GW",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      HU: {
        label: "HUNGARY",
        value: "HU",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      IS: {
        label: "ICELAND",
        value: "IS",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      IQ: {
        label: "IRAQ",
        value: "IQ",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      IE: {
        label: "IRELAND",
        value: "IE",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      IL: {
        label: "ISRAEL",
        value: "IL",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      IT: {
        label: "ITALY",
        value: "IT",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      JO: {
        label: "JORDAN",
        value: "JO",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      KZ: {
        label: "KAZAKHSTAN",
        value: "KZ",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      KE: {
        label: "KENYA",
        value: "KE",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      KV: {
        label: "KOSOVO",
        value: "KV",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      KW: {
        label: "KUWAIT",
        value: "KW",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      KG: {
        label: "KYRGYZSTAN",
        value: "KG",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      LV: {
        label: "LATVIA",
        value: "LV",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      LB: {
        label: "LEBANON",
        value: "LB",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      LS: {
        label: "LESOTHO",
        value: "LS",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      LR: {
        label: "LIBERIA",
        value: "LR",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      LY: {
        label: "LIBYAN ARAB JAMAHIRIYA",
        value: "LY",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      LI: {
        label: "LIECHTENSTEIN",
        value: "LI",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      LT: {
        label: "LITHUANIA",
        value: "LT",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      LU: {
        label: "LUXEMBOURG",
        value: "LU",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      MG: {
        label: "MADAGASCAR",
        value: "MG",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      MW: {
        label: "MALAWI",
        value: "MW",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      ML: {
        label: "MALI",
        value: "ML",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      MT: {
        label: "MALTA",
        value: "MT",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      MR: {
        label: "MAURITANIA",
        value: "MR",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      MU: {
        label: "MAURITIUS",
        value: "MU",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      YT: {
        label: "MAYOTTE",
        value: "YT",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      MD: {
        label: "MOLDOVA",
        value: "MD",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      MC: {
        label: "MONACO",
        value: "MC",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      ME: {
        label: "MONTENEGRO",
        value: "ME",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      MA: {
        label: "MOROCCO",
        value: "MA",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      MZ: {
        label: "MOZAMBIQUE",
        value: "MZ",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      NA: {
        label: "NAMIBIA",
        value: "NA",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      NL: {
        label: "NETHERLANDS",
        value: "NL",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      NE: {
        label: "NIGER",
        value: "NE",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      NG: {
        label: "NIGERIA",
        value: "NG",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      MK: {
        label: "NORTH MACEDONIA",
        value: "MK",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      NO: {
        label: "NORWAY",
        value: "NO",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      OM: {
        label: "OMAN",
        value: "OM",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      PL: {
        label: "POLAND",
        value: "PL",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      PT: {
        label: "PORTUGAL",
        value: "PT",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      QA: {
        label: "QATAR",
        value: "QA",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      RE: {
        label: "REUNION",
        value: "RE",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      RO: {
        label: "ROMANIA",
        value: "RO",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      RU: {
        label: "RUSSIAN FEDERATION",
        value: "RU",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      RW: {
        label: "RWANDA",
        value: "RW",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      SM: {
        label: "SAN MARINO",
        value: "SM",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      ST: {
        label: "SAO TOME AND PRINCIPE",
        value: "ST",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      SA: {
        label: "SAUDI ARABIA",
        value: "SA",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      SN: {
        label: "SENEGAL",
        value: "SN",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      RS: {
        label: "SERBIA",
        value: "RS",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      SC: {
        label: "SEYCHELLES",
        value: "SC",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      SL: {
        label: "SIERRA LEONE",
        value: "SL",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      SK: {
        label: "SLOVAKIA",
        value: "SK",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      SI: {
        label: "SLOVENIA",
        value: "SI",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      SO: {
        label: "SOMALIA",
        value: "SO",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      ZA: {
        label: "SOUTH AFRICA",
        value: "ZA",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      ES: {
        label: "SPAIN",
        value: "ES",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      SZ: {
        label: "SWAZILAND",
        value: "SZ",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      SE: {
        label: "SWEDEN",
        value: "SE",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      CH: {
        label: "SWITZERLAND",
        value: "CH",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      TJ: {
        label: "TAJIKISTAN",
        value: "TJ",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      TZ: {
        label: "TANZANIA, UNITED REPUBLIC OF",
        value: "TZ",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      TG: {
        label: "TOGO",
        value: "TG",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      TN: {
        label: "TUNISIA",
        value: "TN",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      TR: {
        label: "TURKEY",
        value: "TR",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      TM: {
        label: "TURKMENISTAN",
        value: "TM",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      UG: {
        label: "UGANDA",
        value: "UG",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      UA: {
        label: "UKRAINE",
        value: "UA",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      AE: {
        label: "UNITED ARAB EMIRATES",
        value: "AE",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      GB: {
        label: "UNITED KINGDOM",
        value: "GB",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      UZ: {
        label: "UZBEKISTAN",
        value: "UZ",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      VA: {
        label: "VATICAN CITY STATE",
        value: "VA",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      EH: {
        label: "WESTERN SAHARA",
        value: "EH",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      YE: {
        label: "YEMEN",
        value: "YE",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      ZM: {
        label: "ZAMBIA",
        value: "ZM",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
      ZW: {
        label: "ZIMBABWE",
        value: "ZW",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
          {
            label: "German",
            value: "German",
          },
          {
            label: "Italian",
            value: "Italian",
          },
          {
            label: "French",
            value: "French",
          },
          {
            label: "Spanish",
            value: "Spanish",
          },
        ],
      },
    },
  },
  Japan: {
    label: "Japan",
    value: "Japan",
    countries: {
      JP: {
        label: "JAPAN",
        value: "JP",
        states: [],
        languages: [
          {
            label: "Japanese",
            value: "Japanese",
          },
        ],
      },
    },
  },
  LatinAmerica: {
    label: "Latin America",
    value: "LatinAmerica",
    countries: {
      AI: {
        label: "ANGUILLA",
        value: "AI",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      AQ: {
        label: "ANTARCTICA",
        value: "AQ",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      AG: {
        label: "ANTIGUA AND BARBUDA",
        value: "AG",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      AR: {
        label: "ARGENTINA",
        value: "AR",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      AW: {
        label: "ARUBA",
        value: "AW",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      BS: {
        label: "BAHAMAS",
        value: "BS",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      BB: {
        label: "BARBADOS",
        value: "BB",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      BZ: {
        label: "BELIZE",
        value: "BZ",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      BM: {
        label: "BERMUDA",
        value: "BM",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      BO: {
        label: "BOLIVIA",
        value: "BO",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      BR: {
        label: "BRAZIL",
        value: "BR",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      KY: {
        label: "CAYMAN ISLANDS",
        value: "KY",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      CL: {
        label: "CHILE",
        value: "CL",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      CO: {
        label: "COLOMBIA",
        value: "CO",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      CR: {
        label: "COSTA RICA",
        value: "CR",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      DM: {
        label: "DOMINICA",
        value: "DM",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      DO: {
        label: "DOMINICAN REPUBLIC",
        value: "DO",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      EC: {
        label: "ECUADOR",
        value: "EC",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      SV: {
        label: "EL SALVADOR",
        value: "SV",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      FK: {
        label: "FALKLAND ISLANDS (MALVINAS)",
        value: "FK",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      GF: {
        label: "FRENCH GUIANA",
        value: "GF",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      GD: {
        label: "GRENADA",
        value: "GD",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      GP: {
        label: "GUADELOUPE",
        value: "GP",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      GT: {
        label: "GUATEMALA",
        value: "GT",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      GY: {
        label: "GUYANA",
        value: "GY",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      HT: {
        label: "HAITI",
        value: "HT",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      HN: {
        label: "HONDURAS",
        value: "HN",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      JM: {
        label: "JAMAICA",
        value: "JM",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      MQ: {
        label: "MARTINIQUE",
        value: "MQ",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      MX: {
        label: "MEXICO",
        value: "MX",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      MS: {
        label: "MONTSERRAT",
        value: "MS",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      AN: {
        label: "NETHERLANDS ANTILLES",
        value: "AN",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      NI: {
        label: "NICARAGUA",
        value: "NI",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      PA: {
        label: "PANAMA",
        value: "PA",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      PY: {
        label: "PARAGUAY",
        value: "PY",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      PE: {
        label: "PERU",
        value: "PE",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      PR: {
        label: "PUERTO RICO",
        value: "PR",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      SH: {
        label: "SAINT HELENA",
        value: "SH",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      KN: {
        label: "SAINT KITTS AND NEVIS",
        value: "KN",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      LC: {
        label: "SAINT LUCIA",
        value: "LC",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      VC: {
        label: "SAINT VINCENT AND THE GRENADINES",
        value: "VC",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      GS: {
        label: "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS",
        value: "GS",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      SR: {
        label: "SURINAME",
        value: "SR",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      TT: {
        label: "TRINIDAD AND TOBAGO",
        value: "TT",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      TC: {
        label: "TURKS AND CAICOS ISLANDS",
        value: "TC",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      UM: {
        label: "UNITED STATES MINOR OUTLYING ISLANDS",
        value: "UM",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      UY: {
        label: "URUGUAY",
        value: "UY",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      VE: {
        label: "VENEZUELA",
        value: "VE",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      VG: {
        label: "VIRGIN ISLANDS, BRITISH",
        value: "VG",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
    },
  },
  Americas: {
    label: "North America (US and Canada)",
    value: "Americas",
    countries: {
      AS: {
        label: "AMERICAN SAMOA",
        value: "AS",
        states: [],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      CA: {
        label: "CANADA",
        value: "CA",
        states: [
          {
            value: "AB",
            label: "Alberta",
          },
          {
            value: "BC",
            label: "British Columbia",
          },
          {
            value: "MB",
            label: "Manitoba",
          },
          {
            value: "NB",
            label: "New Brunswick",
          },
          {
            value: "NL",
            label: "Newfoundland and Labrador",
          },
          {
            value: "NT",
            label: "Northwest Territories",
          },
          {
            value: "NS",
            label: "Nova Scotia",
          },
          {
            value: "NU",
            label: "Nunavut",
          },
          {
            value: "ON",
            label: "Ontario",
          },
          {
            value: "PE",
            label: "Prince Edward Island",
          },
          {
            value: "QC",
            label: "Quebec",
          },
          {
            value: "SK",
            label: "Saskatchewan",
          },
          {
            value: "YT",
            label: "Yukon",
          },
        ],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
      US: {
        label: "UNITED STATES",
        value: "US",
        states: [
          {
            value: "AL",
            label: "Alabama",
          },
          {
            value: "AK",
            label: "Alaska",
          },
          {
            value: "AZ",
            label: "Arizona",
          },
          {
            value: "AR",
            label: "Arkansas",
          },
          {
            value: "CA",
            label: "California",
          },
          {
            value: "CO",
            label: "Colorado",
          },
          {
            value: "CT",
            label: "Connecticut",
          },
          {
            value: "DE",
            label: "Delaware",
          },
          {
            value: "DC",
            label: "District of Columbia",
          },
          {
            value: "FL",
            label: "Florida",
          },
          {
            value: "GA",
            label: "Georgia",
          },
          {
            value: "HI",
            label: "Hawaii",
          },
          {
            value: "ID",
            label: "Idaho",
          },
          {
            value: "IL",
            label: "Illinois",
          },
          {
            value: "IN",
            label: "Indiana",
          },
          {
            value: "IA",
            label: "Iowa",
          },
          {
            value: "KS",
            label: "Kansas",
          },
          {
            value: "KY",
            label: "Kentucky",
          },
          {
            value: "LA",
            label: "Louisiana",
          },
          {
            value: "ME",
            label: "Maine",
          },
          {
            value: "MD",
            label: "Maryland",
          },
          {
            value: "MA",
            label: "Massachusetts",
          },
          {
            value: "MI",
            label: "Michigan",
          },
          {
            value: "MN",
            label: "Minnesota",
          },
          {
            value: "MS",
            label: "Mississippi",
          },
          {
            value: "MO",
            label: "Missouri",
          },
          {
            value: "MT",
            label: "Montana",
          },
          {
            value: "NE",
            label: "Nebraska",
          },
          {
            value: "NV",
            label: "Nevada",
          },
          {
            value: "NH",
            label: "New Hampshire",
          },
          {
            value: "NJ",
            label: "New Jersey",
          },
          {
            value: "NM",
            label: "New Mexico",
          },
          {
            value: "NY",
            label: "New York",
          },
          {
            value: "NC",
            label: "North Carolina",
          },
          {
            value: "ND",
            label: "North Dakota",
          },
          {
            value: "OH",
            label: "Ohio",
          },
          {
            value: "OK",
            label: "Oklahoma",
          },
          {
            value: "OR",
            label: "Oregon",
          },
          {
            value: "PA",
            label: "Pennsylvania",
          },
          {
            value: "RI",
            label: "Rhode Island",
          },
          {
            value: "SC",
            label: "South Carolina",
          },
          {
            value: "SD",
            label: "South Dakota",
          },
          {
            value: "TN",
            label: "Tennessee",
          },
          {
            value: "TX",
            label: "Texas",
          },
          {
            value: "UT",
            label: "Utah",
          },
          {
            value: "VT",
            label: "Vermont",
          },
          {
            value: "VA",
            label: "Virginia",
          },
          {
            value: "WA",
            label: "Washington",
          },
          {
            value: "WV",
            label: "West Virginia",
          },
          {
            value: "WI",
            label: "Wisconsin",
          },
          {
            value: "WY",
            label: "Wyoming",
          },
        ],
        languages: [
          {
            label: "English",
            value: "English",
          },
        ],
      },
    },
  },
};

export default geoPolData;
